import { render } from "./IconEye.vue?vue&type=template&id=5890e4f6"
const script = {}

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__